export function BlazerWay({ plural = false, className = "" }) {
  return (
    <span className={className}>
      <span className="text-blaze-blueLight">BLAZER{plural ? "S" : ""}</span>{" "}
      <span className="text-blaze-orange">WAY</span>
    </span>
  );
}
